import React from 'react'
import Statusnumber from '../Components/Signup/Statusnumber'

const Status = () => {
  return (
    <Statusnumber/>
  )
}

export default Status